import React, { useEffect, useState } from "react";
import "./App.css";
import { ArrowUpRight } from "lucide-react";
import { KatlasMark } from "./journey/Reveal";
import Hero from "./journey/Hero";
import OldWorld from "./journey/OldWorld";
import WhyBreaks from "./journey/WhyBreaks";
import Manifesto from "./journey/Manifesto";
import GovernedJourney from "./journey/GovernedJourney";
import WhatChanges from "./journey/WhatChanges";
import Patterns from "./journey/Patterns";
import BridgeToCierge from "./journey/BridgeToCierge";
import SiteFooter from "./journey/SiteFooter";

function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <div className={"site-header" + (scrolled ? " is-scrolled" : "")} data-testid="site-header">
      <a href="#top" className="site-header__brand" data-testid="brand">
        <KatlasMark size={26} />
        <span className="site-header__wordmark">KATLAS</span>
        <span className="site-header__divider" />
        <span className="site-header__sub">Authority Journey · A Cierge Labs Storybook</span>
      </a>
      <nav className="site-header__nav">
        <a href="https://platform.katlastechnology.com/" data-testid="nav-platform">
          KATLAS Platform <ArrowUpRight size={13} />
        </a>
        <a href="#old-world" data-testid="nav-journey">The journey</a>
        <a href="#cierge" className="btn btn--accent btn--sm" data-testid="nav-cta">Apply in Cierge Labs</a>
      </nav>
    </div>
  );
}

export default function App() {
  return (
    <div className="aj" data-testid="authority-journey">
      <SiteHeader />
      <Hero />
      <OldWorld />
      <WhyBreaks />
      <Manifesto />
      <GovernedJourney />
      <WhatChanges />
      <Patterns />
      <BridgeToCierge />
      <SiteFooter />
    </div>
  );
}
